import React from 'react'
import { colors } from '../../../constants/colors'
import { offeringSection } from '../../../constants/viemax-constants'
const OurProgram = () => {
  return (
    <section className="py-[41px] px-5">
      <div className="max-w-[330px] mx-auto">
        <h2
          className={`text-[${colors.TEXT_PRIMARY}] text-[32px] leading-[42px] font-bold tracking-[-1px]`}
        >
          Get Viemax Care
          <br />
          Program for{' '}
          <span className={`text-[${colors.TEXT_GREEN}]`}>free</span>
          <br />
          with every purchase
        </h2>
        <h3 className="text-[24px] leading-[42px] font-bold tracking-[-1px] py-10">
          Program Offerings
        </h3>
      </div>
      <div className="space-y-10">
        {offeringSection?.offerings?.map((offering, index) => (
          <div key={`viemax-care-offerings-${index}`}>
            <img
              src={offering.image}
              alt={offering.title}
              className="mt-[8px] relative w-358"
            />
            <h4 className="pl-[1.5px] mt-[12px] text-[20px] text-[#1F2933] font-[600] leading-[26px]">
              {offering.title}
            </h4>
            <p className="text-[16px] text-[#5A6774] mt-3 font-[300] leading-[24px]">
              {offering.desc}
            </p>
          </div>
        ))}
      </div>
    </section>
  )
}

export default OurProgram
